import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "form",
    "emailInput",
    "pillsContainer",
    "pill",
    "emailError",
    "submitButton",
    "submitText",
    "submitLoading",
  ]

  close() {
    this.element.remove()
  }

  focusInput() {
    this.emailInputTarget.focus()
  }

  handleKeydown(event) {
    if (event.key === "Enter" || event.key === "," || event.key === ";") {
      event.preventDefault()
      this.addEmailFromInput()
    } else if (event.key === "Backspace" && this.emailInputTarget.value === "") {
      this.removeLastPill()
    }
  }

  handleBlur() {
    if (this.emailInputTarget.value.trim() !== "") {
      this.addEmailFromInput()
    }
  }

  addEmailFromInput() {
    const email = this.emailInputTarget.value.trim().replace(/[,;]$/, "")
    if (email === "") return

    if (!this.isValidEmail(email)) {
      this.emailErrorTarget.classList.remove("hidden")
      setTimeout(() => this.emailErrorTarget.classList.add("hidden"), 3000)
      return
    }

    // Check for duplicates
    const existingEmails = this.getExistingEmails()
    if (existingEmails.includes(email.toLowerCase())) {
      this.emailInputTarget.value = ""
      return
    }

    this.addPill(email)
    this.emailInputTarget.value = ""
    this.emailErrorTarget.classList.add("hidden")
  }

  addPill(email) {
    const pill = document.createElement("span")
    pill.classList.add(
      "inline-flex",
      "items-center",
      "gap-1",
      "rounded-full",
      "bg-green-100",
      "px-3",
      "py-1",
      "text-sm",
      "text-green-800",
    )
    pill.setAttribute("data-task-pdf-email-modal-target", "pill")
    pill.innerHTML = `
      ${this.escapeHtml(email)}
      <input type="hidden" name="recipient_emails[]" value="${this.escapeHtml(email)}">
      <button type="button" class="ml-1 text-green-600 hover:text-green-800" data-action="click->task-pdf-email-modal#removePill">
        <svg class="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    `
    this.pillsContainerTarget.insertBefore(pill, this.emailInputTarget)
  }

  removePill(event) {
    const pill = event.currentTarget.closest("[data-task-pdf-email-modal-target='pill']")
    if (pill) pill.remove()
  }

  removeLastPill() {
    const pills = this.pillTargets
    if (pills.length > 0) {
      pills[pills.length - 1].remove()
    }
  }

  submit(event) {
    // Add any remaining email in input
    if (this.emailInputTarget.value.trim() !== "") {
      this.addEmailFromInput()
    }

    const emails = this.getExistingEmails()
    if (emails.length === 0) {
      event.preventDefault()
      this.emailErrorTarget.classList.remove("hidden")
      return
    }

    // Show loading state
    this.submitButtonTarget.disabled = true
    this.submitTextTarget.classList.add("hidden")
    this.submitLoadingTarget.classList.remove("hidden")
  }

  getExistingEmails() {
    return Array.from(
      this.pillsContainerTarget.querySelectorAll("input[name='recipient_emails[]']"),
    ).map((input) => input.value.toLowerCase())
  }

  isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
